export default __webpack_public_path__ + "static/media/apple-btn@2x.f624c481.png";